<template>
    <section class="section">
        <div class="container">

            <div class="columns">
                <div class="column is-8 is-offset-2">
                    <div class="content">

            <section aria-labelledby="fair-lending-title">

            <h1 class="is-size-1 section-title has-text-primary">WebBank Fair Lending Statement</h1>
            <br>
  <h2>Overview</h2>
  <p>
    Fair lending laws and regulations seek to ensure fair and unbiased treatment for all applicants and customers in every aspect of lending, including credit decisions. WebBank is committed to ensuring that individuals and businesses are treated fairly, consistently, and without discrimination on any prohibited basis throughout the credit lifecycle. This is a core component of our mission to deliver responsible financial products and services with integrity, transparency, and respect.
  </p>

  <h2>Commitment to Fairness</h2>
  <p>
    WebBank is committed to providing fair, equitable, and non-discriminatory access to credit in all jurisdictions where we operate. We uphold the highest standards of corporate responsibility in our lending activities, whether through our direct lending programs or through partnerships with financial technology companies and others.
  </p>
  <p>
    Our Fair Lending principles apply to all stages of the credit lifecycle—from marketing and pre-application inquiries to credit evaluation, underwriting, loan origination, account servicing, to the end of the customer relationship. We strive to ensure that all policies, practices, and interactions with applicants and customers promote inclusion and equal opportunity.
  </p>

  <h2>Compliance with Laws</h2>
  <p>
    It is WebBank’s policy to comply with all applicable fair lending laws and regulations, including but not limited to the Equal Credit Opportunity Act (ECOA) and Regulation B, the Fair Housing Act, and applicable state and local fair lending laws and regulations.
  </p>
  <p>
    Federal law requires that applicants be treated equitably, without regard to race, color, religion, national origin, sex, marital status, age, disability, familial status, receipt of public assistance income, or the exercise of rights under the Consumer Credit Protection Act.
  </p>

  <h2>Our Responsibility</h2>
  <p>
    Discrimination on any prohibited basis in lending is inconsistent with WebBank’s values and will not be tolerated. We recognize that fair access to credit is essential to economic opportunity and community growth. Every WebBank employee and partner has a responsibility to uphold these principles by ensuring that credit decisions and customer interactions throughout the lending cycle are free from intentional or unintentional bias.
  </p>

  <h2>Ongoing Commitment</h2>
  <p>
    WebBank maintains robust compliance and monitoring programs designed to detect, prevent, and remediate potential fair lending risks. We also invest in training and oversight to ensure that all staff and partners understand and adhere to our Fair Lending policies. Through these efforts, WebBank continually seeks to promote fairness, inclusion, and financial empowerment.
  </p>
</section>
            <br>
            <br>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
export default {

    created() {
        document.title = "Fair Lending Statement - WebBank";
    },

}
</script>

<style scoped>
.patriot-hero {
    background: rgba(31, 55, 107, 0.5) url(https://assets.webbank.com/patriot-act.png);
    box-shadow: inset 0 0 0 1000px rgba(255, 255, 255, .4);
    background-position: center;
    background-size: cover;
    min-height: 400px;
}
</style>
